import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';
import { GaTrackingEventLabel, GATrackingEventType } from '~shared/modules/ga-tracking/constants';

export class ZRPElementsClickApplicationEvent implements ApplicationEvent {
  type = ApplicationEventType.Search_0_results_click;

  constructor(private action: GATrackingEventType, private element: GaTrackingEventLabel | string) {}

  getPayload(): any {
    return {
      action: this.action,
      element: this.element,
    };
  }
}
